// extracted by mini-css-extract-plugin
export var animationAbsolute = "_28-q";
export var animationRelative = "_28-p";
export var backdropBlur = "_28-0";
export var detailLabelCell = "_28-12";
export var detailTable = "_28-11";
export var detailValueCell = "_28-13";
export var docIconBox = "_28-1d";
export var docIconBoxMd = "_28-1f";
export var docIconBoxSm = "_28-1e";
export var docTypeRow = "_28-16";
export var docTypeRowInner = "_28-17";
export var dropdownMatchDatePicker = "_28-3";
export var evidenceCardContent = "_28-1c";
export var fileUploadSpin = "_28-j";
export var gorgiasOpenButton = "_28-15 _28-d";
export var gorgiasTicketCard = "_28-14";
export var heroModalFooterButton = "_28-18";
export var hiddenContainer = "_28-o";
export var iconPrimary = "_28-1g";
export var iconQuaternary = "_28-1i";
export var iconTertiary = "_28-1h";
export var integrationCard = "_28-1";
export var integrationLogoBox = "_28-2";
export var mainColumnSticky = "_28-1b";
export var maxWidthContainer = "_28-19";
export var modalContentBody = "_28-a";
export var modalHeaderImage = "_28-5";
export var modalImageLabel = "_28-7";
export var modalImageOverlay = "_28-6";
export var modalImageSubtitle = "_28-9";
export var modalImageTitle = "_28-8";
export var modalImageWrapper = "_28-4";
export var modalStickyFooter = "_28-b";
export var removeButton = "_28-e";
export var sidebarColumn = "_28-1a";
export var spinner = "_28-i";
export var timelineLine = "_28-y";
export var timelineLineBlack = "_28-10 _28-y";
export var timelineLineGray = "_28-z _28-y";
export var timelineLineHeight = "_28-x";
export var tlDotActivate = "_28-u";
export var tlDotActivateAnim = "_28-t";
export var tlDotHide = "_28-s";
export var tlDotHideAnim = "_28-r";
export var tlLineActivate = "_28-w";
export var tlLineActivateAnim = "_28-v";
export var uploadHint = "_28-n";
export var uploadIconBox = "_28-k";
export var uploadLabel = "_28-m";
export var uploadText = "_28-l";
export var uploadZone = "_28-f";
export var uploadZoneCursorDefault = "_28-h";
export var uploadZoneCursorPointer = "_28-g";
export var uploadedFileRow = "_28-c";
export var viewButton = "_28-d";